export enum AttendanceDistributionEnum {
  LESS_ACTIVE_CONVERSATION = "LESS_ACTIVE_CONVERSATION",
  FIRST_ASSUME = "FIRST_ASSUME",
  ALPHABETICAL_ORDER = "ALPHABETICAL_ORDER"
}